export default {
  uChoicePc: {
    sysTitle: '花美美商城',
    searchKey: '输入关键字搜索',
    moreFilter: '更多筛选',
    filterItemM: '筛选项：',
    submit: '提交',
    reset: '重置',
    determine: '确定',
    cancel: '取消',
    return: '返回',
    close: '关闭',
    preservation: '保存',
    totalItems: '共 {count} 条',
    pleaseSelect: '请选择',
    loading: 'Loading...',
    networkError: '网络错误',
    fetchFailed: '获取数据失败',
    delete: '删除',
    deleteMessage: '删除提示',
    edit: '编辑',
    operation: '操作',
    operationTips: '操作提示',
    add: '新增',
    empty: '清空',
    loginOut: '退出登录',
    changeLang: '切换语言',
    loginOutTips: '退出系统, 是否继续?',
    goodsList: '商品列表',
    suggestGoodsList: '推荐商品清单',
    goodsManage: '商品管理',
    goodsClassifyList: '商品分类列表',
    operationManage: '运营管理',
    businessOrderList: '商单列表',
    businessOrderManage: '商单管理',
    activityList: '活动列表',
    activityManage: '活动管理',
    userList: '用户列表',
    userManage: '用户管理',
    switch: '选择',
    rememberPassword: '记住密码',
    login: '登录',
    welcomeLogin: '欢迎登录',
    pleaseEnterCode: '请输入验证码',
    pleaseEnterPass: '请输入密码',
    pleaseEnterPhone: '请输入手机号',
    istributionSystemTAPD: '花美美商城',
    changeLanguage: '切换语言',
    inputProductIDSearch: '输入商品名称搜索',
    serialNumber: '序号',
    productName: '商品名称',
    addProduct: '添加商品',
    editProduct: '编辑商品',
    productId: '商品ID',
    tiktokshoProductId: 'tiktoksho商品Id',
    activeName: '活动名称',
    activeState: '活动状态',
    activeStartTime: '活动开始时间',
    activeEndTime: '活动结束时间',
    productType: '商品分类',
    fristProductType: '商品一级分类',
    secondProductTypee: '商品二级分类',
    prices: '价格',
    productSales: '销量',
    tikTokProductName: 'Tik Tok商店名称',
    lastUpdateTime: '最近一次更新时间',
    commissionLink: '佣金链接',
    productState: '商品状态',
    configured: '已配置',
    notConfigured: '未配置',
    listed: '已上架',
    notListed: '未上架',
    launch: '上架',
    takeDown: '下架',
    settingSample: '设置小样',
    exportCommissionChain: '导出佣金链接',
    importCommissionChain: '导入佣金链接',
    pleaseInter: '请输入',
    label: '标签',
    newProductsShelf: '新品上架商品',
    highCommissionProducts: '高佣金商品',
    bestSellingProduct: '爆款商品',
    setTagsBatch: '批量设置标签',
    launchProductConfirm: '是否上架该商品吗？',
    takeDownProductConfirm: '是否下架该商品吗？',
    changeProductStatusBatch: '批量修改商品状态',
    changeProductStatusBatchConfirm: '是否批量修改选中商品状态吗？',
    productDetail: '商品详情',
    productInformation: '商品信息',
    READY: '准备中',
    UPCOMING: '即将开始',
    ONGOING: '进行中',
    CLOSED: '已关闭',
    UNSPECIFIED: '未指定',
    affiliatedActivity: '所属活动',
    pricesMax: '商品最高价格',
    pricesMin: '商品最低价格',
    totalSales: '总销量',
    launchProduct: '上架商品',
    downloadTemplate: '下载模板',
    downloadTemplateLink: '下载导入佣金链接模板',
    downloadTemplateProduct: '下载导入商品模板',
    manuallySynchronizeProduct: '手动同步商品数据',
    takeDownProduct: '下架商品',
    batchModifyProductStatuses: '批量修改商品状态',
    activeId: '活动ID',
    updateTime: '更新时间',
    productPhotoLink: '商品图片链接',
    productPhoto: '商品图片',
    productIntroduction: '商品介绍',
    commissionLinkTable: '佣金链接表',
    linkName: '链接名称',
    commissionRate: '佣金比例',
    link: '链接',
    openPlan: 'open plan',
    editCommissionLink: '编辑链接',
    tagManagement: '标签管理',
    productCode: '商品编号',
    addLink: '添加链接',
    newProduct: '新品上架商品',
    highCommissionProduct: '高佣金商品',
    hotProduct: '爆款商品',
    labelingMethod: '打标签方式',
    hitTags: '打标签',
    cancelMethod: '取消标签',
    more: '更多',
    importCommissionChainTemplate: '导入佣金链接模板',
    importProductChainTemplate: '导入商品模板',
    importProductChain: '导入商品',
    advancedFilter: '高级筛选',
    pleaseImproveConfiguration: '请完善配置',
    pleaseCheckFileFormat: '请检查文件格式',
    isExclusiveMCNMembers: '是否MCN成员专属',
    nickname: '昵称',
    pleaseEnterNickname: '输入用户名称搜索',
    avatar: '头像',
    followerCount: '粉丝数',
    gender: '性别',
    totalLikes: '点赞总数',
    joinedMCN: '是否加入MCN',
    joinTime: '加入时间',
    durationMembership: '加入时长',
    firstLoginTime: '首次登录时间',
    TIKTOKID: 'TIKTOK ID',
    isMCNInfluencer: '是否MCN达人',
    yes: '是',
    no: '否',
    accountId: '账户id',
    nameRecommendedProductList: '推荐商品清单名称',
    recommendedProductDetials: '推荐商品清单详情',
    importRecommendedProductTemplate: '导入推荐商品清单模板',
    interNameRecommendedProductList: '输入推荐商品清单名称',
    numberProductsList: '清单商品数',
    numberProducts: '商品数量',
    products: '商品',
    soltNumber: '排序值',
    changeSoltNumber: '修改排序',
    creatTime: '创建时间',
    status: '状态',
    enabled: '已启用',
    disabled: '已停用',
    createChecklist: '创建清单',
    deactivate: '停用',
    enable: '启用',
    sureDeactivateRecommendedProduct: '是否停用该推荐商品清单吗？',
    sureEnableRecommendedProduct: '是否启用该推荐商品清单吗？',
    sureDeleteRecommendedProduct: '确认删除该推荐商品清单吗？',
    sortingEarlierAppearsSequence: '排序值越大越靠前',
    addRecommendedProduct: '新增推荐商品清单',
    importProduct: '导入商品',
    editRecommendedProduct: '编辑推荐商品清单',
    templateDownload: '模板下载',
    deleteAssociatedProductsList: '确认删除该商品清单关联商品吗？',
    inputProductCategorySearch: '输入商品分类名称搜索',
    categoryName: '分类名称',
    fristCategoryName: '一级分类名称',
    secondCategoryName: '二级分类名称',
    addFristCategory: '新增一级分类',
    addCategory: '新增分类',
    editCategory: '编辑分类',
    addSubordinate: '添加下级',
    deleteAssociatedCategory: '确认删除该分类吗？',
    secondaryClassificationCannotDeleted: '存在二级分类，不允许删除',
    inputPromotionTaskSearch: '输入商单标题搜索',
    creatPromotionTask: '创建商单',
    editPromotionTask: '编辑商单',
    promotionTaskDetial: '商单详情',
    RECRUITING: '报名中',
    ENDED: '已结束',
    FULL: '已报满',
    OFFLINE: '下架',
    NEW: '新单',
    HOT: '热门',
    URGENT: '急招',
    sample: '样品',
    fixedFee: '固定费用',
    commission: '佣金',
    fixedFeeCommission: '固定费用+佣金',
    promotionTaskTittle: '商单标题',
    brandName: '品牌名/店铺名',
    formCooperation: '合作形式',
    otherMessage: '其他信息',
    applicationDeadline: '报名截止时间',
    changeStatus: '修改状态',
    deletePromotionTask: '确认删除该商单吗？',
    promotionalPoster: '宣传图',
    brandIntroduction: '品牌介绍',
    missionObjective: '任务目标',
    paymentMethod: '结算方式',
    explanationSettlementMethod: '结算方式说明',
    expertRequirements: '达人要求',
    deadline: '截止时间',
    contentTeleaseTime: '内容出片时间',
    settlementTime: '结算时间',
    platformRequirements: '平台要求',
    precautions: '注意事项',
    registrationLink: '报名链接',
    primaryClassificationBusinessDocuments: '商单一级分类',
    secondaryClassificationBusinessOrders: '商单二级分类',
    inputActivitySearch: '输入活动名称搜索',
    addActivity: '新增活动',
    editActivity: '编辑活动',
    deleteActivity: '确定删除活动吗？',
    editAppUserInfo: '修改用户信息',
    addAppUserInfo: '新增用户信息',
    accountManage: '账户管理',
    systemManage: '系统管理',
    nickName: '昵称',
    totalLike: '点赞数',
    totalNumberVideos: '视频总数',
    addAccount: '新增账户',
    email: '邮箱',
    highestPriceMustBeGreaterThanLowest: '最高价格不能低于最低价格',
    endTimeEarlierStartTime: '结束时间不能小于开始时间',
    deadlineEarlierContentDeliveryTime: '截止时间不能小于内容出片时间',
    statusInconsistent: '状态不一致，请重新选择',
    pleaseEnterAccountPhoneSearch: '请输入账户、手机号搜索',
    accountName: '账户名称',
    accountStatus: '账户状态',
    tiktokshopProductId: 'tiktokshop商品Id',
    deletePcUsersTask: '确认删除该账户吗？',
    changePcUsersTaskStatus: '确认修改该账户账号状态吗？',
    username: '用户名',
    resultPassword: '重置密码',
    editAccount: '编辑账户',
    password: '密码',
    repeatPassword: '确认密码',
    pleaseEnterPasswordsNotMatch: '密码不一致，请重新输入',
    home: '首页',
    cart: '购物车',
    register: '注册',
    myOrders: '我的订单',
    allCategories: '全部分类',
    searchProducts: '搜索商品',
    tip: '提示',
    confirm: '确定',
    total: '合计',
    flowerMallSlogan: '鲜花商城，为您传递美好',
    flowerMallDesc: '精选优质鲜花，用心传递每一份美好',
    shopNow: '立即选购',
    featuredCategories: '特色分类',
    hotProducts: '热销商品',
    viewMore: '查看更多',
    seasonPromo: '限时促销',
    seasonPromoDesc: '精选鲜花限时优惠，低至5折起',
    viewPromos: '查看优惠',
    newArrivals: '新品推荐',
    categoryDesc: '探索我们精心准备的各类鲜花',
    productCategory: '商品分类',
    allCategoriesDesc: '探索我们所有的鲜花品类',
    default: '默认',
    priceLowToHigh: '价格从低到高',
    priceHighToLow: '价格从高到低',
    salesVolume: '销量',
    newest: '最新',
    totalProducts: '共 {count} 件商品',
    productDetails: '商品详情',
    productReviews: '商品评价',
    relatedProducts: '相关推荐',
    addToCart: '加入购物车',
    addedToCart: '已添加到购物车',
    buyNow: '立即购买',
    quantity: '数量',
    salesUnit: '件',
    myshoppingCart: '我的购物车',
    shoppingCart: '购物车',
    cartEmpty: '购物车是空的，快去选购心仪的鲜花吧',
    selectAll: '全选',
    totalItemsCount: '共 {count} 件',
    clearCart: '清空购物车',
    confirmClearCart: '确认清空购物车吗？',
    cleared: '已清空',
    checkout: '去结算',
    selectProductsFirst: '请先选择商品',
    order: '订单',
    orderNo: '订单编号',
    orderDetail: '订单详情',
    all: '全部',
    pendingPayment: '待付款',
    pendingUse: '待使用',
    paid: '已付款',
    shipped: '已发货',
    completed: '已完成',
    cancelled: '已取消',
    payNow: '立即付款',
    cancelOrder: '取消订单',
    confirmCancelOrder: '确认取消该订单吗？',
    proceedingToPayment: '正在前往支付',
    reviewOrder: '评价',
    orderManagement: '订单管理',
    searchOrderNo: '搜索订单号',
    orderPerson: '下单人：',
    orderTime: '下单时间：',
    details: '详情',
    totalPieces: '共 {count} 件商品',
    pendingDelivery: '待发货',
    createAccount: '创建账户',
    registerWelcome: '注册 FLB Mall 账户，开始购物之旅',
    usernamePlaceholder: '请输入用户名',
    phoneNumber: '手机号',
    phonePlaceholder: '请输入手机号',
    passwordPlaceholder: '请输入密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    hasAccount: '已有账户？',
    goShopping: '去逛逛',
    registerSuccess: '注册成功',
    registerFailed: '注册失败',
    enterUsername: '请输入用户名',
    usernameLength: '用户名长度在 2 到 20 个字符之间',
    invalidPhone: '请输入有效的手机号',
    enterPassword: '请输入密码',
    passwordLength: '密码长度在 6 到 30 个字符之间',
    enterConfirmPassword: '请再次输入密码',
    passwordMismatch: '两次输入的密码不一致',
    personalCenter: '个人中心',
    personalInfo: '个人资料',
    notLoggedIn: '未登录',
    deliveryAddress: '收货地址',
    securitySettings: '安全设置',
    accountPassword: '账户密码',
    passwordDesc: '建议定期更换密码以保护账户安全',
    boundPhone: '绑定手机',
    notBound: '未绑定',
    modify: '修改',
    avatarTip: '点击更换头像',
    emailPlaceholder: '请输入邮箱',
    invalidEmail: '请输入有效的邮箱地址',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    flowers: '鲜花',
    preservedFlowers: '永生花',
    pottedPlants: '盆栽',
    giftBoxes: '礼盒',
    categoriesTitle: '花美美花卉',
    companyTitle: '花美美科技',
    brandStory: '品牌故事',
    customerService: '客户服务',
    helpCenter: '帮助中心',
    afterSales: '售后服务',
    deliveryInfo: '配送信息',
    aboutUs: '关于我们',
    companyIntro: '公司介绍',
    joinUs: '加入我们',
    contactUs: '联系我们',
    cutFlowers: '优质鲜切花',
    customerPraise: '客户五星好评',
    newsTitle: '新闻动态',
    shoppingGuide: '购物指南',
    beginnerGuide: '新手指南',
    shoppingFlow: '购物流程',
    memberIntro: '会员介绍',
    distributionMethod: '配送方式',
    distributionRange: '配送范围',
    distributionTime: '配送时间',
    freightDesc: '运费说明',
    footerPaymentMethod: '支付方式',
    onlinePayment: '在线支付',
    cashOnDelivery: '货到付款',
    afterSalesService: '售后服务',
    returnPolicy: '退换货政策',
    complaintSuggestion: '投诉建议',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    copyright: 'Copyright © 2024 FLB Mall All Rights Reserved',
    icpRecord: 'ICP备案号：粤ICP备XXXXXXXX号',
    footerBrandDesc: 'FLB Mall 鲜花商城，精选全球优质鲜花，用心传递每一份美好与祝福。',
    navtitle: '功能导航',
    navhome: '首页',
    flower: '鲜花',
    immortal: '永生花',
    potted: '盆栽',
    about: '关于我们',
    contantMe: '联系我们',
    phone: '手机号',
    navemail: '联系邮箱',
    businessHours: '营业时间',
    address: '公司地址',
    companyName: '沐花科技',
    introTitle: '依托云南得天独厚的鲜花资源优势与斗南成熟的业态，沐花打破了传统鲜花贸易的地域限制 与 信息壁垒',
    introHighlight: '地域限制 与 信息壁垒',
    introDesc1:
      '沐花科技（云南沐花科技有限公司）坐落于享誉全球的“亚洲花都”—中国云南昆明斗南。我们是一家深耕花卉产业，集跨境花卉贸易、全产业链数据集成应用、供应链数智化管理于一体的创新型花卉科技企业。',
    introDesc2:
      '我们不仅致力于将中国高品质的鲜切花与优质种苗输送到全球市场（重点辐射东南亚、中东以及中亚地区），更通过自主研发的“中国花卉产业全链数据要素综合应用平台”，用数字化、智能化手段赋能传统花卉产业，实现从“传统花田”到“云花出海”的跨越。',
    businessTitle: '核心板块业务',
    advantageTitle: '我们的优势',
    missionTitle: '使命',
    missionDesc: '用科技传递自然之美 助力云花香飘世界',
    visionTitle: '愿景',
    visionDesc: '成为全球领先的花卉产业数智化服务商，构建绿色、互联、可持续的花卉跨境生态',
    valueTitle: '价值观',
    valueDesc: '用户向导、善待鲜花、数智赋能、高效创新、全球共赢',
    partnerTitle: '合作伙伴',
    logout: '退出登录',
    vipTag: 'VIP',
    emailText: '邮箱',
    companyText: '企业',
    shippingAddress: '收货地址',
    defaultAddress: '默认',
    addAddress: '新增地址',
    logoutTip: '确定退出当前账号的登录状态吗?',
    registerTitle: '注册新账号',
    phoneLabel: '联系电话',
    placeholderInput: '请填写',
    emailLabel: '邮箱',
    codeLabel: '验证码',
    getCodeText: '获取',
    pwdLabel: '设置密码',
    confirmPwdLabel: '再次确认',
    cancelBtn: '取消',
    registerBtn: '注册账号',
    codeCountdownTip: 's后重新获取',
    phoneRuleTip: '请填写正确手机号',
    emailRuleTip: '请输入合法邮箱地址',
    codeRuleTip: '请输入验证码',
    pwdRuleTip: '密码长度至少6位',
    pwdDiffTip: '两次输入密码不一致',
    codeSendSuccess: '验证码已发送',
    inputProductName: '输入商品名称',
    simplifiedChinese: '简体中文',
    english: 'English',
    collapse: '收起',
    expand: '展开',
    salesPriority: '销量优先',
    pricePriority: '价格优先',
    sortBy: '排序',
    user: '用户',
    previousImage: '上一张',
    nextImage: '下一张',
    articleDetail: '文章详情',
    homeBannerSlogan: '甄选好花 任您挑选',
    unitPrice: '单价',
    perBundle: '/扎',
    stock: '库存',
    productSpec: '商品规格',
    color: '颜色',
    productDescription: '商品描述',
    remark: '备注',
    orderProductInfo: '下单商品信息',
    orderProduct: '下单商品',
    category: '品类',
    specification: '规格',
    unit: '单位',
    subtotal: '小计',
    logisticsInfo: '物流信息',
    hotSale: '热销',
    companyProfile: '公司简介',
    companyProfileDesc1: '花美美科技有限公司（MM Flora），公司总部坐落于亚洲最大的鲜花交易核心枢纽——中国昆明斗南',
    companyProfileDesc2: '作为一家深耕“数智花卉”领域的创新型科技企业，花美美致力于通过前沿AI技术重塑传统花卉产业链，倾力构建“中国鲜花全产业链跨境贸易服务平台”。',
    companyProfileDesc3:
      '秉承“中国鲜花，香飘世界”的品牌使命，花美美聚焦中国优质鲜切花的规模化出口贸易、跨境供应链体系优化。我们通过标准化的订单管理与技术赋能，打破鲜花跨境贸易的难点和卡点，全面推动中国传统鲜花贸易企业的数智化转型。',
    companyProfileDesc4:
      '面向未来，花美美将持续以AI为核心驱动力、数据为导向，不断深耕并优化鲜花产业生态闭环。我们将以严苛的标准化品质管控为基石，以花美美为桥梁，确保每一朵鲜花都能以最卓越的姿态、最快捷的速度，完美绽放在世界各地。',
    officeAddress: '办公地址：',
    officeAddressValue: '云南省昆明市呈贡区斗南花花世界3号馆512',
    contactPhone: '联系电话：',
    globalPartners: '全球合作伙伴',
    aboutCompany: 'About Us',
    contactUsEn: 'Contact Us',
    globalPartnersEn: 'Global Partners',
    passwordLogin: '密码',
    emailLogin: '邮箱',
    codeLogin: '验证码',
    emailOrPhone: '邮箱/手机号',
    verifyCode: '验证码',
    forgetPassword: '忘记密码？',
    getCode: '获取',
    noAccount: '还没有账号？',
    goRegister: '去注册',
    required: '必填',
    forgotPassword: '忘记密码',
    userName: '用户名',
    pleaseFillIn: '请填写',
    newPassword: '新密码',
    confirmNewPassword: '再次确认新密码',
    pleaseEnterPassword: '请输入密码',
    passwordNotMatch: '两次输入的密码不一致',
    passwordResetSuccess: '密码重置成功',
    emailFormatError: '邮箱格式不正确',
    codeRequired: '请先获取验证码',
    countdownText: '秒后重新获取',
    noReceivingAddress: '暂无收货地址',
    editUserInfo: '编辑个人信息',
    country: '国家',
    company: '公司',
    save: '保存',
    pleaseSelectCountry: '请选择国家',
    addNewAddress: '添加新地址',
    editNewAddress: '编辑地址',
    consignee: '收货人',
    region: '地区',
    detailedAddress: '详细地址',
    submitSuccess: '地址添加成功',
    phoneFormatError: '联系电话格式不正确',
    pleaseSelectConsignee: '请输入收货人',
    pleaseInputPhone: '请输入联系电话',
    pleaseSelectRegion: '请选择完整地区信息',
    pleaseInputDetailedAddress: '请输入详细地址',
    pleaseSelectAddress: '请选择收货地址',
    pleaseEnterTureCode: '请输入正确的验证码',
    verificationMethod: '验证方式',
    NoDataAvailable: '暂无数据',
    PriceFromHighToLow: '价格高到低',
    LowToHighPrice: '价格低到高',
    deleteAddressTips: '确定删除此收货地址吗？',
    deleteSuccess: '删除成功',
    deleteSingleProductTips: '确定将【{0}】从购物车中删除吗？',
    deleteMutipleProductTips: '确定删除所选的 {0} 个商品吗',
    checkoutOrderTitle: '核对订单信息',
    receivingAddress: '收货地址',
    confirmProduct: '确认商品',
    gift: '赠品',
    giftLoadFailed: '赠品查询失败，请重新提交以重试',
    remarks: '备注',
    remarksPlaceholder: '请填写',
    totalPayable: '应付总额：',
    submitOrder: '提交订单',
    cartIsEmpty: '购物车为空，请先添加商品',
    NoOrder: '暂无订单',
    OrderNotFound: '未找到订单，换个关键词再试试',
    loginExpiredRelogin: '登录信息已过期，请重新登录！',
    loginExpired: '登录信息已过期',
    networkTimeout: '网络超时，请稍后再试！',
    businessTypeFlowerTrade: '专注鲜花贸易20年',
    productSelectionFlower: '严选优质产品',
    productFeatureFlower: '全程冷链产品',
    customsServiceFlower: '快速通关清关',
    coverageCountriesFlower: '业务覆盖20国',
    noLogisticsInformation: '暂无物流信息',
    defaultBusinessHours: '周一至周日9:00-18:00',
    defaultCompanyAddress: '云南省昆明市呈贡区斗南街道斗南社区北区139号',
    defaultCopyright: '©2026 云南花美美科技有限公司.版权所有 滇ICP2025070574号-2',
    toPay: '去付款',
    OrderSubmitted: '订单已提交',
    keepThePhoneOpen: '我们将在24小时内与您取得联系，请保持电话通畅',
    GoToMyOrder: '去我的订单',
    GoToMyHome: '回首页逛逛',
    DeleteTheSelectedItem: '删除所选商品',
    store: '门店',
    PleaseSelectAStore: '请选择门店',
    phoneAreaCode: '电话区号',
    setDefaultSuccess: '设置默认地址成功',
    Joined: '已加入',
    ToBeConfirmed: '待确认',
    PleaseCheckTheGoodsStore: '请勾选同一门店商品',
    PleaseCheckTheSameSalesMode: '请勾选同一取货方式的商品',
    evaluateContent1: '玫瑰色泽饱满、花期持久，冷链包装完好，多次采购品质稳定，是长期信赖的云南鲜切花供应商。',
    evaluateContent2: '合作三年的老客户了！花美美的鲜切花品质真的没话说，价格透明，物流稳定，是我们花店最靠谱的供应商！',
    evaluateContent3: '他们不仅供货，还会给我们做养护培训，有问题随时都能找到人解答，这种专业的服务真的太省心了。',
    evaluateContent4: '做花卉生意这么多年，花美美是我遇到最专业的服务商！',
    evaluateContent5: '一站式采购太方便了！鲜花、盆栽、永生花在这里都能搞定，不用再找好几家供应商。',
    evaluateContent6: '做东南亚跨境花卉生意，花美美的冷链包装和清关能力太专业了，合作两年从没出过岔子。',
    evaluateContent7: '品类丰富，品质优于多数产地，损耗低，定制供货灵活，东南亚市场认可度高，值得长期合作',
    newZealand: '新西兰',
    australia: '澳大利亚',
    myanmar: '缅甸',
    korea: '韩国',
    russia: '俄罗斯',
    thailand: '泰国',
    from: '来自'
  }
}
